import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'spe-csv-step-upload',
  templateUrl: './step-upload.component.html',
  styleUrls: ['./step-upload.component.scss'],
  imports: [ReactiveFormsModule, MatButtonModule]
})
export class StepUploadComponent {
  @Input() firstLoading: boolean = true;
  @Input() filesDataForm!: FormGroup;

  @Output() eventFileChange = new EventEmitter<Event>();
  @Output() eventSubmit = new EventEmitter<void>();

  onFileChange(event: Event): void {
    this.eventFileChange.emit(event);
  }

  onSubmit(): void {
    this.eventSubmit.emit();
  }
}
